import { CartType } from './common'
import { LogisticCartUrgency } from './logistic_cart'
import { HistoryStatusObject } from './status'

export enum LogisticFilialStatus {
  waiting = 'waiting',
  denied = 'denied',
  in_process = 'in_process',
  given = 'given',
  accepted = 'accepted',
  for_delivery = 'for_delivery',
  no_accepted = 'no_accepted',
}

export interface LogisticFilialSpecialist {
  pk: string
  phone: string
  full_name: string
}

export interface LogisticFilialBranch {
  id: number
  name: string
}

export interface LogisticFilial {
  id: number
  created_at: string
  date_embossment: string
  client_full_name: string
  phone: string
  pan: string
  cart_type: CartType
  degree_urgency: LogisticCartUrgency
  status: LogisticFilialStatus
  comment?: string
  specialist?: LogisticFilialSpecialist

  branch?: LogisticFilialBranch
  status_title?: string
  cart_type_title?: string
  degree_urgency_title?: string

  status_list?: Array<HistoryStatusObject>
}
